<template>
  <v-app-bar
    class="bg-primary"
    height="90"
    flat
  >
    <slot name="outside-left" />
    <slot name="title">
      <img
        src="https://www.idrettsforbundet.no/Static/gfx/logo-hvit.svg"
        alt="Norges Idrettsforbund"
        height="70"
      >
    </slot>
    <slot name="inside-left" />
    <v-spacer />
    <slot name="inside-right" />
    <slot name="menu" />
    <slot name="outside-right" />
  </v-app-bar>
</template>

<script>
export default {
  name: "HeaderBlock"
};
</script>
